function equalizeHowToHeaders() {
  document.querySelectorAll(".how-to-list").forEach((list) => {
    const headers = Array.from(list.querySelectorAll(".how-to__header"))
    if (!headers.length) return

    headers.forEach((header) => {
      header.style.minHeight = ""
    })

    const tallest = headers.reduce(
      (max, header) => Math.max(max, header.offsetHeight),
      0,
    )

    headers.forEach((header) => {
      header.style.minHeight = `${tallest}px`
    })
  })
}

function debounce(fn, wait) {
  let timeout

  return () => {
    clearTimeout(timeout)
    timeout = setTimeout(fn, wait)
  }
}

window.addEventListener("load", equalizeHowToHeaders)
window.addEventListener("resize", debounce(equalizeHowToHeaders, 60))
